import React from 'react';
import { Button } from 'ui-components/components/button';
import { defineMessages, FormattedMessage } from 'react-intl';

const messages = defineMessages({
  gridMarkReceived: {
    description: 'gridMarkReceived.markAsReceived',
    defaultMessage: 'Mark as Received',
    id: 'UxU+py',
  },
});

const MarkReceivedButton = () => {
  return (
    <Button theme='tertiary'>
      <FormattedMessage {...messages.gridMarkReceived} />
    </Button>
  );
};

export default MarkReceivedButton;
